<template>
  <div class="Brand">
    <div class="Brand_w">
      <div class="Brand_left">
        <div class="Brand_tit">Brand Kit</div>
        <div class="Brand_tit1">
          Welcome to the DO Network Brand and Marketing Guidelines Page!
        </div>
        <div class="Brand_tit2">
          When promoting DO Network in advertisements, articles, websites, or
          printed materials, please strictly adhere to the following guidelines
          to ensure consistent messaging and a professional brand image.
        </div>
        <div class="rightul">
          <!-- <div class="rightli">
            <img src="../../../assets/pc/brand/2.png" class="bimg" />
            <div class="righttitb">Brand guidelines</div>
          </div> -->
          <a
            href="https://fastcdn.donetwork.io/official/Assets_Logo.rar"
            target="_blank"
          >
            <div class="rightli1">
              <img src="../../../assets/pc/brand/3.png" class="bimg" />
              <div class="righttita">Asset downloads</div>
            </div>
          </a>
        </div>

        <div class="Brand_tit3">DO Network Brand</div>
        <div class="Brandbox">
          <div class="Brandtit">Logotype</div>
          <img src="../../../assets/pc/brand/1.png" class="img1" />
          <div class="Brandtit1">
            The DO Network brand logo features a clean and modern design, with
            the icon based on a rounded rectangle containing a gradient blue "D"
            element. This highlights the brand's initial and enhances
            recognition. The typography uses a sans-serif style paired with a
            blue theme, conveying a sense of technology and professionalism. The
            overall style is fresh and contemporary.
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtit">Clearspace</div>

          <div class="Brandtit1">
            To ensure the clarity and recognizability of the brand logo, please
            maintain sufficient white space around it to prevent interference
            from other patterns, images, or page edges. Below are the minimum
            spacing requirements for the corporate logo and wordmark.
          </div>
          <img src="../../../assets/pc/brand/6.png" class="img2" />
          <div class="imgbox">
            <img src="../../../assets/pc/brand/7.png" class="img3" />
            <img src="../../../assets/pc/brand/8.png" class="img4" />
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtit">Logo Usage Guidelines</div>

          <div class="Brandtit1">
            The following are actions to avoid when using the DO Network brand
            logo
          </div>

          <div class="imgbox1">
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/9.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t add shadows behind the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/10.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t add outlines to the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/11.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t stretch the logo</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/12.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t apply logo in low resolution</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/13.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t use logo as a frame for imagery</div>
              </div>
            </div>
            <div class="imgboxli">
              <img src="../../../assets/pc/brand/14.png" class="img5" />
              <div class="liimg">
                <img src="../../../assets/pc/brand/15.png" class="img6" />
                <div class="litit">Don’t place on low contrast colors</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Brandbox">
          <div class="Brandtit">Colors</div>
          <div class="colorbox">
            <div class="colorli">
              <div class="colorsc"></div>
              <div class="colorst">
                <div class="colorsr1"></div>
                <div class="colorsr2"></div>
                <div class="colortit">DO Network Gradient Colors</div>
              </div>
            </div>
            <div class="colorli">
              <div class="colorsc1"></div>
              <div class="colorst">
                <div class="colorsr1"></div>

                <div class="colortit">#5991FD</div>
              </div>
            </div>
            <div class="colorli">
              <div class="colorsc2"></div>
              <div class="colorst">
                <div class="colorsr2"></div>
                <div class="colortit">#2F52CE</div>
              </div>
            </div>
          </div>
          <div class="colorbox">
            <div class="colorli">
              <div class="colorsc3">#4573E7</div>
              <div class="colorst">
                <div class="colorsr3"></div>

                <div class="colortit3">Font Color</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Brandbox1">
          <div class="assets">Assets</div>
          <a
            href="https://fastcdn.donetwork.io/official/Assets_Logo.rar"
            target="_blank"
          >
            <div class="assetsbox">
              <img src="../../../assets/pc/brand/16.png" />
              <div class="assettit">Download Assets</div>
            </div>
          </a>
          <div class="asset1">Main Logotype</div>
          <div class="assetall">
            <img src="../../../assets/pc/brand/17.png" class="imgasset" />
            <div class="assetbtn">
              <a href="https://fastcdn.donetwork.io/official/Logo.rar"> <div>PNG</div></a>
              <a href="https://fastcdn.donetwork.io/official/Logo_SVG.rar"> <div>SVG</div></a>
            </div>
          </div>
          <div class="asset1">LOGO Mark</div>
          <div class="assetall">
            <img src="../../../assets/pc/brand/18.png" class="imgasset" />
            <div class="assetbtn">
              <a href="https://fastcdn.donetwork.io/official/DO_Logo.rar"> <div>PNG</div></a>
              <a href="https://fastcdn.donetwork.io/official/DO_Logo_SVG.rar"> <div>SVG</div></a>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="Brand_line">Logotype</div>
      <div class="Brand_right">
        <div class="rightul">
          <div class="rightli">
            <img src="../../../assets/pc/brand/2.png" class="bimg" />
            <div class="righttitb">Brand guidelines</div>
          </div>
          <div class="rightli1">
            <img src="../../../assets/pc/brand/3.png" class="bimg" />
            <div class="righttita">Brand guidelines</div>
          </div>
          <div class="rightli1">
            <img src="../../../assets/pc/brand/4.png" class="bimg" />
            <div class="righttita">Asset downloads</div>
          </div>
          <div class="rightli">
            <img src="../../../assets/pc/brand/5.png" class="bimg" />
            <div class="righttitb">Asset downloads</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="less">
.w1352 {
  width: 1200px;
  margin: 0 auto;
}
.w1300 {
  width: 67%;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.Brand {
  background: #fff;
  margin-top: 159px;
  .Brand_w {
    width: 1190px;
    margin: 0 auto;
    display: flex;
    .Brand_left {
      width: 1080px;
      margin: 0 auto;
      .Brand_tit {
        height: 112px;
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 80px;
        color: #000000;
        line-height: 112px;
        //text-align: left;
        font-style: normal;
        text-transform: none;
        text-align: center;
      }
      .Brand_tit1 {
        margin-top: 16px;
        height: 31px;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #000000;
        line-height: 31px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .Brand_tit2 {
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 18px;
        color: #61666b;
        line-height: 30px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .rightul {
        display: flex;
        justify-content: center;
        margin-top: 50px;
        .rightli {
          width: 223px;
          height: 45px;
          background: #4573e7;
          border-radius: 6px 6px 6px 6px;
          display: flex;
          margin-right: 30px;
          cursor: pointer;
          .bimg {
            width: 28px;
            height: 28px;
            margin-left: 24px;
            margin-top: 9px;
          }
          .righttitb {
            height: 45px;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }
        .rightli1 {
          width: 223px;
          height: 45px;
          background: #f2f5f9;
          border-radius: 6px 6px 6px 6px;
          display: flex;
          cursor: pointer;
          .bimg {
            width: 28px;
            height: 28px;
            margin-left: 24px;
            margin-top: 9px;
          }
          .righttita {
            height: 45px;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 16px;
            color: #4573e7;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }
      }
      .Brand_tit3 {
        font-family: Poppins, Poppins;
        font-weight: 900;
        font-size: 60px;
        color: #000000;
        line-height: 77px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-top: 80px;
      }
      .Brandbox {
        margin-top: 60px;
        .Brandtit {
          height: 45px;
          font-family: Poppins, Poppins;
          font-weight: 700;
          font-size: 30px;
          color: #000000;
          line-height: 45px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .img1 {
          width: 420px;
          height: 68px;
          margin-top: 33px;
        }
        .Brandtit1 {
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 18px;
          color: #61666b;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-top: 30px;
        }
        .img2 {
          width: 756px;
          height: 232px;
          margin-top: 13px;
        }
        .imgbox {
          display: flex;
          margin-top: 80px;
          .img3 {
            width: 310px;
            height: 310px;
            margin-right: 40px;
          }
          .img4 {
            width: 310px;
            height: 310px;
          }
        }
        .imgbox1 {
          margin-top: 30px;
          display: flex;
          flex-wrap: wrap;
          width: 1080px;
          justify-content: space-between;
          .imgboxli {
            margin-bottom: 40px;
            .img5 {
              width: 357px;
              height: 130px;
            }
            .liimg {
              display: flex;
              .img6 {
                width: 20px;
                height: 20px;
                margin-top: 5px;
                margin-right: 8px;
              }
              .litit {
                height: 30px;
                font-family: Poppins, Poppins;
                font-weight: 500;
                font-size: 14px;
                color: #000000;
                line-height: 30px;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }
          }
        }
        .colorbox {
          display: flex;
          justify-content: space-between;
          .colorli {
            margin-top: 20px;
            .colorsc {
              width: 497px;
              height: 230px;
              background: linear-gradient(91deg, #5991fd 0%, #2f52ce 100%);
              border-radius: 10px 10px 10px 10px;
            }
            .colorsc1 {
              height: 230px;
              width: 268px;
              background: #5991fd;
              border-radius: 10px 10px 10px 10px;
            }
            .colorsc2 {
              height: 230px;
              width: 267px;
              background: #2f52ce;
              border-radius: 10px 10px 10px 10px;
            }
            .colorst {
              display: flex;
              margin-top: 8px;
              .colorsr1 {
                width: 20px;
                height: 20px;
                background: #5991fd;
                border-radius: 50%;
                margin-right: 8px;
                margin-top: 5px;
              }
              .colorsr2 {
                width: 20px;
                height: 20px;
                background: #2f52ce;
                border-radius: 50%;
                margin-top: 5px;
                margin-right: 8px;
              }
              .colortit {
                font-family: Poppins, Poppins;
                font-weight: 600;
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                background: linear-gradient(90deg, #5991fd, #2f52ce);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              .colorsr3 {
                width: 20px;
                height: 20px;
                background: #4573e7;
                border-radius: 50%;
                margin-top: 5px;
                margin-right: 8px;
              }
              .colortit3 {
                height: 30px;
                font-family: Poppins, Poppins;
                font-weight: 600;
                font-size: 14px;
                color: #5991fd;
                line-height: 30px;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }
            }
            .colorsc3 {
              height: 180px;
              width: 1080px;
              background: #4573e7;
              border-radius: 10px 10px 10px 10px;
              padding-left: 998px;
              padding-top: 151px;
            }
          }
        }
      }
      .Brandbox1 {
        margin-top: 115px;
        padding-bottom: 240px;
        .assets {
          height: 78px;
          font-family: Poppins, Poppins;
          font-weight: 900;
          font-size: 60px;
          color: #000000;
          line-height: 77px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
        .assetsbox {
          display: flex;
          width: 220px;
          height: 45px;
          line-height: 45px;
          background: #4573e7;
          border-radius: 6px 6px 6px 6px;
          margin-top: 40px;
          img {
            width: 24px;
            height: 24px;
            margin-left: 24px;
            margin-top: 11px;
            margin-right: 8px;
          }
          .assettit {
            height: 24px;
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            text-transform: none;
          }
        }
        .asset1 {
          height: 30px;
          font-family: Poppins, Poppins;
          font-weight: 500;
          font-size: 18px;
          color: #000000;
          line-height: 30px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-top: 60px;
          margin-bottom: 20px;
          text-align: left;
        }
        .assetall {
          width: 780px;
          display: flex;
          justify-content: space-between;
          .imgasset {
            width: 578px;
            height: 168px;
          }
          .assetbtn {
            margin-top: 35px;
            div {
              width: 118px;
              height: 45px;
              background: rgba(106, 148, 255, 0.2);
              border-radius: 84px 84px 84px 84px;
              font-family: Poppins, Poppins;
              font-weight: 500;
              font-size: 18px;
              color: #4573e7;
              line-height: 45px;
              text-align: center;
              cursor: pointer;
              margin-bottom: 24px;
            }
          }
        }
      }
    }
    .Brand_line {
      width: 2px;
      height: 3886px;
      background: #f2f5f9;
      border-radius: 0px 0px 0px 0px;
      margin-left: 3px;
    }
    .Brand_right {
      width: 480px;
      .rightul {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-left: 20px;
        .rightli,
        .rightli1 {
          width: 223px;
          height: 45px;
          line-height: 45px;

          border-radius: 6px 6px 6px 6px;
          margin-bottom: 24px;
          display: flex;
          .bimg {
            width: 28px;
            height: 28px;
            margin-top: 9px;
            margin-left: 24px;
          }
          .righttitb {
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 16px;
            color: #ffffff;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            margin-left: 8px;
          }
          .righttita {
            font-family: Poppins, Poppins;
            font-weight: 600;
            font-size: 16px;
            color: #4573e7;
            line-height: 45px;
            text-align: right;
            font-style: normal;
            text-transform: none;
            margin-left: 8px;
          }
        }
        .rightli1 {
          background: #f2f5f9;
        }
        .rightli {
          background: #4573e7;
        }
      }
    }
  }
}
</style>
